/** @jsxImportSource @emotion/react */
import React from 'react'
import { EnterpriseForm, EnterprisePreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/EnterprisesContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, enterprisesManagement } = breadcrumbItems

const EnterprisesCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <EnterpriseForm />
        </div>
        <div css={styles.right}>
          <EnterprisePreview />
        </div>
      </div>
    </Provider>
  )
}

export default EnterprisesCreate;
